export default "__VITE_ASSET__m049mVGT__"